import React, { useRef } from 'react';

var useResizeHandle = function useResizeHandle(_ref) {
  var onDragStart = _ref.onDragStart,
      onDrag = _ref.onDrag,
      onDragEnd = _ref.onDragEnd,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 10 : _ref$minWidth;
      _ref.isLast;
  var startX = useRef();
  var startWidth = useRef();
  var containerRef = useRef();

  var triggerMove = function triggerMove(handler, event) {
    var increasing = startX.current - event.clientX < 0;
    handler(Math.max(startWidth.current - startX.current + event.clientX, minWidth), increasing, {});
  };

  var onMouseMove = function onMouseMove(event) {
    event.stopPropagation();
    event.preventDefault();
    triggerMove(onDrag, event);
  };

  var onMouseUp = function onMouseUp(event) {
    event.stopPropagation();
    event.preventDefault();
    triggerMove(onDragEnd, event);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  var onMouseDown = function onMouseDown(event) {
    event.stopPropagation();
    event.preventDefault();
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    startX.current = event.clientX;
    startWidth.current = containerRef.current.offsetWidth;
    triggerMove(onDragStart, event);
  };

  var HandleComponent = function HandleComponent(_ref2) {
    var _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? 'resize-handle' : _ref2$className;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      React.createElement("div", {
        className: className,
        onMouseDown: onMouseDown
      })
    );
  };

  return {
    containerRef: containerRef,
    Handle: HandleComponent
  };
};

export { useResizeHandle };
//# sourceMappingURL=useResizeHandle.js.map
